import { TOGGLE_REVIEW_MODAL, SET_CLICKED_VALIDATION_ERROR, NAVIGATION_TO_SAME_PAGE, LOCATION_CHANGE } from 'ContentEditorUI/redux/actions/actionTypes';
// @ts-ignore Not migrated yet
import { getPaneNameFromPath } from 'ContentEditorUI/utils/helpers';
import { produce } from 'immer';
import has from 'hs-lodash/has';
const initialState = {
  currentPane: ''
};
const updateStateWithNewLocation = (pathname, state) => {
  const pane = getPaneNameFromPath(pathname);
  if (!pane) {
    return state;
  }
  if (state.errorClicked) {
    state.errorClicked = false;
    state[pane] = true;
  }
  state[state.currentPane] = true;
  state.currentPane = pane;
  return state;
};
export const panesVisitStatusReducer = (state = initialState, {
  type,
  payload
}) => produce(state, draft => {
  switch (type) {
    case LOCATION_CHANGE:
      return updateStateWithNewLocation(payload.pathname, draft);
    case NAVIGATION_TO_SAME_PAGE:
      if (draft.errorClicked) {
        draft.errorClicked = false;
        draft[payload] = true;
        return draft;
      }
      return draft;
    case TOGGLE_REVIEW_MODAL:
      if (!has(draft, 'review')) {
        draft.review = true;
        return draft;
      }
      return draft;
    case SET_CLICKED_VALIDATION_ERROR:
      draft.errorClicked = true;
      return draft;
    default:
      return draft;
  }
});
export default panesVisitStatusReducer;